import { gql } from "@apollo/client"

export const GET_PARTICIPANT = gql`
  query ParticipantProfile($participant_id: ID!, $organization_id: ID!) {
    participant(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_name_preferred
      participant_phone_primary
      participant_email_account
      participant_city_primary
      participant_state_primary
      participant_zip_code_primary
      organization_id
      program_list
      participant_membership_status
    }
  }
`
export const GET_SERVICES = gql`
  query getTemplatesByOrganization(
    $organization_id: ID!
    $template_type: String
  ) {
    getTemplatesByOrganization(
      organization_id: $organization_id
      template_type: $template_type
    ) {
      template_title
      template_name
      template_collection
      template_type
      template_availability
    }
  }
`
